import { render, staticRenderFns } from "./NsBadge.vue?vue&type=template&id=73cd9acc&"
import script from "./NsBadge.vue?vue&type=script&lang=js&"
export * from "./NsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cd9acc')) {
      api.createRecord('73cd9acc', component.options)
    } else {
      api.reload('73cd9acc', component.options)
    }
    module.hot.accept("./NsBadge.vue?vue&type=template&id=73cd9acc&", function () {
      api.rerender('73cd9acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsBadge.vue"
export default component.exports